<script>
import appConfig from "@/app.config";
import ChangePassword from "@/components/ChangePassword2";

export default {
  components: {
    ChangePassword,
  },
  page: {
    title: "Thay đổi mâth khẩu",
    meta: [{ name: "description", content: appConfig.description }],
  },
};
</script>
<template>
  <div class="authentication-bg d-flex align-items-center pb-0 vh-100">
    <div class="content-center w-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-10">
            <div class="card">
              <div class="card-body py-5">
                <div class="row align-items-center">
                  <div class="col-lg-4 ms-auto">
                    <div class="py-2">
                      <h3 class="text-primary">THAY ĐỔI MẬT KHẨU</h3>
                      <div class="divided"></div>
                    </div>
                    <ChangePassword />
                  </div>
                  <div class="col-lg-5 mx-auto">
                    <img
                        src="@/assets/images/error.png"
                        alt
                        class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end container -->
    </div>
  </div>
</template>
